/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

/**
 * **The payload viewer, loaded when a payload is shown** (`#1331`).
 *
 * The viewer is built on CodeMirror (`PayloadViewer.codemirror.tsx`), which was imported statically
 * through the test inspector, the produced-ads view and the response mapping editor, so every console
 * page carried it in the main bundle. This wrapper keeps the name and the props every caller already
 * uses and loads the implementation on first render, so a page that never shows a payload never
 * downloads CodeMirror.
 */

import React from 'react';
import { LoadingState } from '../ui/states';
import type { PayloadViewerProps } from './PayloadViewer.codemirror';

export type { PayloadViewerProps } from './PayloadViewer.codemirror';

const LazyPayloadViewer = React.lazy(() =>
  import('./PayloadViewer.codemirror').then((module) => ({ default: module.PayloadViewer })),
);

export const PayloadViewer: React.FC<PayloadViewerProps> = (props) => (
  <React.Suspense fallback={<LoadingState py={4} label="Loading the viewer…" />}>
    <LazyPayloadViewer {...props} />
  </React.Suspense>
);
